import classnames from "classnames";
import React, { type FC } from "react";
import { useAlertContext } from "src/components/Alert/AlertContext";
import styles from "./styles.module.scss";

interface AlertListBoxProps {
  className?: string;
}

const AlertListBox: FC<AlertListBoxProps> = ({ className }) => {
  const { alerts } = useAlertContext();
  return (
    <div className={classnames(styles.alert_list_box, className)}>{alerts}</div>
  );
};

export default AlertListBox;
